<template>
  <div class="cover">
    <div class="video-cover">
      <video muted autoplay loop src="/wp-content/interactivos/las-falsas-unidades-de-factchecking/videos/cover.mp4" />
    </div>
    <div class="meta text-center">
      <div>        
        <div class="row justify-content-center">
          <div class="col-md-7 col-12">
            <div class="headline">
              <!-- <a class="d-block mb-3" href="https://elfoco.pe/" target="_blank">
                <img height="30px" class="brand-logo" src="https://elfoco.pe/wp-content/uploads/2021/01/cropped-LOGOS-ELFOCO-white-1.png" alt="El Foco" />
              </a> -->
              <h1>
                <div>Las falsas unidades de </div>
                <div><i>fact-checking</i></div>
                <div>en las instituciones públicas
                </div>
              </h1>
            </div>
            <h2 class="mt-3">{{ $t('cover.subtitle') }}</h2>          
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-11 col-md-7 col-lg-6 text-center">            
            <Contenido/>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-11 col-md-7 col-lg-6 text-center">            
            <button @click="openVideoMiniDoc()" class="btn-video-go">Ver minidocumental</button>
          </div>
        </div>
      </div>
    </div>
	</div>
</template>

<style lang="scss">
  

  @keyframes slideDownArrow {
    from {
      opacity: 1;
      bottom: 100px;
    }

    to {
      opacity: 0;
      bottom: 0px;
    }
  }

  .container-logo {
    position: relative;
    width: 100%;
    z-index: 1;
  }


  .btn-video-go {
    margin: 15px 0;
    color: #000;
    background-color: #fff;
    border: none;
    padding: 10px 15px;
    font-weight: 400;
    font-size: 15px;
    font-family: "Nunito";
    text-transform: uppercase;

    &:hover {
      background-color: #e3e3e3;
    }
  }

  .container-arrow-down {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 5px 0px 0 0;
    z-index: 9999;
    text-align: center;

    .icon-down {
      font-size: 12px;
      color: #e3e3e3;
      position: relative;
      display: inline-block;
      width: 100%;
      max-width: 360px;
      margin: 0 auto;
      text-align: center;
      animation: slideDownArrow 2s infinite ease-in-out;
      transition: transform 1.5s ease-in-out;

      svg {
        fill: #68d09a4a;
        color: #68d09a;
        stroke-width: 0;
        width: 32px;
        height: 32px;
      }
    }
  }
</style>

<script>

  import Contenido from '@/components/Contenido'

  export default {
    name: 'CoverHome',
    components: {
      Contenido
    },
    data: () => ({
      popUp: false
    }),
    methods: {
      togglePopUp(){
        this.popUp = !this.popUp
      },
      openVideoMiniDoc() {
        document.querySelector(`#foco_video_minidoc_item`).scrollIntoView({ block: "center", inline: "nearest" })
      }
    }
  }
</script>
